<template>
  <div>
    <el-form
      ref="rowForm"
      :model="rowData"
      label-width="120px"
      class="demo-ruleForm"
    >
    <el-form-item label="会员姓名" prop="nickName">
        <span>{{ rowForm.nickName }}</span>
    </el-form-item>
    <el-form-item label="会员电话" prop="phone">
      <span>{{ rowForm.phone }}</span>
    </el-form-item>
    <el-form-item label="申请时间" prop="applyDate">
      <span>{{ rowForm.applyDate }}</span>
    </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    rowForm: Object
  },
  data () {
    return {
      rowData: {
        nickName: '',
        phone: '',
        applyDate: ''
      }
    }
  },
  mounted () {
    if (this.rowForm) {
      this.rowData = this.rowForm
    }
  }

}
</script>

